module.exports = __webpack_public_path__ + "media/02.b8f4fa8a.mp3";